import { useQueryAnonUserCount } from 'modules/anonymousUserTracking/hooks/useQueryAnonUserCount';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { Body2 } from 'ui/theme/typography/components';
import { ActivityCellWrapper, StyledSkeleton } from '../AnonymousUserTracking.styled';

export const ActivityCell = ({ criteria }: { criteria: AnonUserCriteria }) => {
  const { count, isLoading, errorMessage } = useQueryAnonUserCount(criteria.id);

  if (errorMessage) return null;

  return (
    <ActivityCellWrapper data-test="criteria-activity-cell">
      {isLoading ? (
        <StyledSkeleton height={40} />
      ) : (
        <>
          <Body2>{count}</Body2> added
        </>
      )}
    </ActivityCellWrapper>
  );
};
